import type { DeepPartial } from '@luna/utils-ts';

import type { SavingsConfig } from '../ProductsConfig';
import { settingsDetails } from './settings-details-config/HR';

export const savings: DeepPartial<SavingsConfig> = {
    statements: {
        showNewCustomStatementCard: true,
    },
    allowedPurposeSavingsFlags: ['domesticTransferAllowed'],
    settingsDetails,
    newTransfer: {
        sideMenuLabel: 'account.main.newTransfer',
    },
    cancellation: {
        signing: {
            showCancelledAccountInfo: true,
            showTargetAccountInfo: true,
        },
        focusPage: {
            errorPageTitle: 'account.scheduledTermDepositCancelation.stripeErrorTitle',
            successPageTitle: 'account.details.services.cancellation.step1.modalHeadline',
            signingPageTitle: 'account.details.services.cancellation.step1.modalHeadline',
            optionsPageTitle: 'account.details.services.cancellation.step1.modalHeadline',
        },
        successMessage: 'account.details.services.cancellation.signing.success',
    },
    layout: {
        productInfo: {
            showBalanceAndDisposableAmounts: true,
        },
    },
};
